export default __webpack_public_path__ + "static/media/fam.64bb528c.jpg";